// extracted by mini-css-extract-plugin
export default {"title":"TitleWithUnderline_title__+bbAR"};